import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import MessageBlock from '../../../../../../../../features/components/Form/MessageBlock'

import { selfAccountSelector } from '../../../../../../../../modules/selectors/selfAccounts'

import { FACEBOOK_BUSINESS_MANAGER_ID } from '../../../../../../../../pages/Settings/RightHolderProfile/fields'

import useStyles from '../styles'

const MissingClientAppWarningMessage = () => {
  const classes = useStyles()

  const { t } = useTranslation()

  const selfAccount = useSelector(selfAccountSelector)
  const selfAccountFacebookBmId = selfAccount?.[FACEBOOK_BUSINESS_MANAGER_ID]

  return (
    <MessageBlock title="MISSING APP" borderColor="warning" className={classes.messageBlock}>
      Please confirm the app has been shared with business manager ID {selfAccountFacebookBmId}
      {'. '}
      {t('Otherwise, please select another goal.')}
    </MessageBlock>
  )
}

export default MissingClientAppWarningMessage
